module.exports = __webpack_public_path__ + "img/ic_record_cancel.83f4e1c0.png";